import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import { connect as connectFormik } from 'formik';
import BbRadioWrapper from '../../styling/BbRadioWrapper';
import BbInput from '../../styling/bbInput';
import { hasPermission } from "../../../store/apiWrapper";

const style = { padding: "0 0.75em", minHeight: "3em" }

class Ess extends React.Component {

    componentDidMount() {
        this.props.updateEssLabel();
    }

    render() {
        return (
            <React.Fragment>
                <div className="columns">
                    <div className="column" style={{ display: "flex", flexWrap: "wrap" }}>
                        <BbRadioWrapper callback={() => { this.props.formik.setFieldValue('ess.type', '1');}}
                            checked={this.props.formik.values.ess.type === '1'}
                            id="type-1"
                            name="type"
                            value="include" label={this.props.translate("Search.Marketing.FinalOwners")} />
                        <BbRadioWrapper callback={() => { this.props.formik.setFieldValue('ess.type', '2'); }}
                            checked={this.props.formik.values.ess.type === '2'}
                            id="type-2"
                            name="type"
                            value="include" label={this.props.translate("Search.Marketing.Ess")} />
                    </div>
                </div>
                {!hasPermission(null, 'EconomicGroupSberbankMethodology') && hasPermission(null, 'EconomicGroupEdit') &&
                    <div className="columns">
                        <div className="column bb-input-label-column is-6" style={{ ...style }}>
                            <div className="bb-radio-group-wrapper">
                                <div className="bb-radio-group-row">
                                    <div className="control">
                                        <Translate id="Search.Marketing.Ess.MinimalShare" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="column bb-input-column is-6" style={style}>
                            <div className="control">
                                <BbInput
                                    name="ess.minShare"
                                    type="number"
                                    min={0}
                                    max={100}
                                    placeholder={{ type: 'inline' }}
                                    style={{ paddingLeft: "0", paddingRight: "0" }}
                                    label=""
                                />
                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
        )
    }
}

export default withLocalize(connectFormik(Ess));



